import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SettingsService } from '../services/settings.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private http: HttpClient,
    private settings: SettingsService
  ) { }

  login(
    data: { username: string, password: string, aplicacionId: string, aplicacionVersion: string }
  ) {
    
    data.aplicacionId = this.settings.APP_ID;
    data.aplicacionVersion = this.settings.APP_VERSION;

    return this.http.post(this.settings.URL_BASE + 'login', data);

  }
}
